module.exports = __webpack_public_path__ + "media/brand/Swipe-72220829.svg";